import styled from '@emotion/styled/macro';
import { StyledInputProps } from '../../../components/Input/Input.types';
import rem from '../../../utils/rem/rem';

export const ComparePage = styled.div`
  padding: 0 ${rem(32)} ${rem(32)} ${rem(32)};
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

export const DropdownButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: ${rem(4)};
`;

export const DropdownWrapper = styled.div<StyledInputProps>`
  display: flex;
  align-items: ${({ errorText }) => (errorText !== '' ? 'flex-start' : 'flex-end')};
  gap: ${rem(30)};
`;

export const ButtonWrapper = styled.div<StyledInputProps>`
    button {
        margin-bottom: ${rem(6)};
        margin-top: ${({ errorText }) => (errorText !== '' ? rem(5) : rem(0))};
    }
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: ${rem(16)} 36px;
  padding-bottom: ${rem(8)};
`;

export const RadioWrapper = styled.div`
`;

export const ExportButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;